export { default } from './MenuWide'
